import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import { formatNumber } from "../../utils/formatNumber";
import i18next from "i18next";
import { BALANCE_RELOAD } from "../../constant";
import { Text, Tooltip, useColorModeValue } from "@chakra-ui/react";
import AnimateCount from "../../pages/WebSocket/components/AnimateCount";
import { specialTextGradientStyle } from "../../utils/specialTextGradientStyle";
import useDeviceType from "../../hook/useDeviceType";

const BalanceAmount = ({ balanceStyle }) => {
  const walletCurrency = useSelector((state) => state.isWalletCurrency); //從redux store中取isWalletCurrency的值 存到walletCurrency變數中
  const isCurrencyExchange = useSelector((state) => state.isCurrencyExchange);
  const dispatch = useDispatch();

  const textColor = useColorModeValue("dark.100", "light.100");

  const isMobile = useDeviceType() === "Mobile";

  const location = useLocation();

  const { pathname } = location;

  const { color, fontSize, fontWeight } = balanceStyle || {};

  useEffect(() => {
    const fetchDataPeriodically = () => {
      dispatch({ type: "GET_BALANCE" });
    };

    const apiIterval = setInterval(() => {
      fetchDataPeriodically();
    }, BALANCE_RELOAD);

    return () => clearInterval(apiIterval);
  }, []);

  const balance = useMemo(() => {
    return isCurrencyExchange?.[walletCurrency]?.exchange_amount || 0;
  }, [walletCurrency, isCurrencyExchange]);

  const inGameBox = pathname.includes("gamebox");

  return (
    <Tooltip label={inGameBox ? i18next.t("common.playing") : balance}>
      <Text
        as="span"
        sx={
          color || inGameBox
            ? {}
            : isMobile
            ? {
                color: "white",
              }
            : specialTextGradientStyle
        }
        color={color ? color : inGameBox ? "white" : "transparent"}
        fontSize={inGameBox ? "18px" : fontSize} // 根據pathname判斷字體大小
        fontWeight={fontWeight}
      >
        {inGameBox ? (
          `(${i18next.t("common.playing")})`
        ) : (
          <AnimateCount
            variant={{
              mass: 0.8,
              stiffness: 60,
              damping: 17.5,
            }}
            value={balance}
          />
        )}
      </Text>
    </Tooltip>
  );
};

export default BalanceAmount;
